import api from '../api';

export const getFields = (entityType) => {
  return api.get(`/tql/fields/${entityType}`);
};

export const searchFields = (entityType, keyword, limit) => {
  return api.get(`/tql/fields/${entityType}/${keyword}/${limit}`);
};
